import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Actions, State, Selectors } from '@grandvisionhq/auth';
import { LOADING, SUCCESS, connect, loadingState, statusUninit, statusSuccess, statusFailed, successState } from '@grandvisionhq/state';

const UNAVAILABLE = {
    status: 'unavailable'
};
function isDataUnavailable(state) {
    return state.status === 'unavailable';
}
function isDataLoading(state) {
    return state.status === LOADING;
}
function isDataSuccess(state) {
    return state.status === SUCCESS;
}
const fetchIfUninit = (props)=>{
    if (statusUninit(props.auth.userSettings.userDataState.userData)) {
        props.fetchUserData();
    }
};
const resourceToDataState = (resource, defaultState, extractSuccess)=>{
    if (statusSuccess(resource)) {
        return extractSuccess(resource);
    } else if (statusFailed(resource)) {
        return UNAVAILABLE;
    } else {
        return defaultState;
    }
};
function WithUserData(Component) {
    const wrappedName = Component.displayName || Component.name || 'Component';
    class Wrapper extends (React.Component) {
        componentDidMount() {
            const { auth  } = this.props;
            if (State.isInitialized(auth)) {
                this.props.recoverSession();
            }
            if (State.isLoggedIn(auth)) {
                fetchIfUninit(this.props);
            }
        }
        componentDidUpdate(prevProps) {
            if (State.isUninitialized(prevProps.auth) && State.isInitialized(this.props.auth)) {
                this.props.recoverSession();
            }
            if (State.isInitialized(prevProps.auth) && State.isLoggedIn(this.props.auth)) {
                fetchIfUninit(this.props);
            }
        }
        render() {
            const { auth  } = this.props;
            const { email  } = auth;
            let userData1 = loadingState();
            if (!State.isUninitialized(auth) && !State.isInitialized(auth)) {
                userData1 = UNAVAILABLE;
            }
            if (State.isLoggedIn(auth)) {
                userData1 = resourceToDataState(auth.userSettings.userDataState.userData, loadingState(), (userData)=>successState(swcHelpers.objectSpread({}, userData.result, {
                        email
                    }))
                );
            }
            return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, this.props, {
                userData: userData1
            }));
        }
    }
    Wrapper.displayName = `WithUserData(${wrappedName})`;
    const mapStateToProps = (state)=>({
            auth: Selectors.getAuth(state)
        })
    ;
    const ConnectedWrapper = connect(mapStateToProps, {
        recoverSession: Actions.LoginActions.recoverSession,
        fetchUserData: Actions.UserDataActions.fetchUserData
    })(Wrapper);
    return (props)=>props.isMyAccountEnabled ? /*#__PURE__*/ React.createElement(ConnectedWrapper, swcHelpers.extends({}, props)) : /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props, {
            userData: UNAVAILABLE
        }))
    ;
}

export { UNAVAILABLE, WithUserData, isDataLoading, isDataSuccess, isDataUnavailable };
//# sourceMappingURL=UserDataProvider.js.map
